import { nonAccentVietnamese } from '@iso/lib/helpers/utility';
import * as _ from 'lodash';

import ticketActions from './actions';

const initialState = {
  tickets: [],
  isFetched: false,
  errorMessage: '',
  status: '',

  ticket: {},
  users: [],
  conversations: [],
  loading: false,
  total: 0,
  draftMessage: null, // Message từ response khi lưu nháp
};

export default function ticketReducer(state = initialState, action) {
  switch (action.type) {
    case ticketActions.SET_TICKETS: {
      const { tickets, total } = action.payload;

      return {
        ...state,
        tickets,
        total,
        isFetched: true,
        ticket: {},
        conversations: [],
      };
    }

    case ticketActions.LOAD_MORE_TICKETS:
      return {
        ...state,
        loading: true,
      };
    case ticketActions.SET_LOAD_MORE_TICKETS: {
      const { tickets, total } = action.payload;

      return {
        ...state,
        tickets: _.uniqBy([
          ...state.tickets,
          ...tickets,
        ], 'id'),
        total,
        isFetched: true,
        loading: false,
      };
    }

    case ticketActions.CREATE_TICKET:
      const { id, message, isDraft: payloadIsDraft } = action.payload;
      
      console.log('[Reducer] CREATE_TICKET:', {
        id,
        message,
        isDraft: payloadIsDraft,
        payload: action.payload,
      });
      
      // * Forwarded
      if (!id) {
        return {
          ...state,
          status: 'CREATED', 
        };
      }

      const draftMsg = message || (payloadIsDraft ? 'Đã lưu vào nháp' : null);
      console.log('[Reducer] CREATE_TICKET - draftMessage:', draftMsg);

      return {
        ...state,
        tickets:[
          {
            ...action.payload,
          },
          ...state.tickets,
        ],
        ticket: payloadIsDraft ? action.payload : state.ticket,
        status: 'CREATED',
        // Lưu message để hiển thị notification
        draftMessage: draftMsg,
      };
    case ticketActions.UPDATE_TICKET:
      return {
        ...state,
        tickets: [
          ...state.tickets.map(ticket => {
            return ticket.id === action.payload.id ? {
              ...ticket, 
              ...action.payload,
            } : ticket;
          })
        ],
        ticket: {
          ...state.ticlet,
          ...action.payload,
        },
        status: 'UPDATED',
      };
    case ticketActions.DELETE_TICKET:
      return {
        ...state,
        tickets: state.tickets.filter(ticket => ticket.id !== action.payload.id),
        status: 'DELETED',
      };

    case ticketActions.SET_USERS:
      return {
        ...state,
        users: action.payload,
      };

    case ticketActions.SET_TICKET:
      return {
        ...state,
        ticket: action.payload,
      };

    case ticketActions.SET_CONVERSATIONS:
      // Sort conversations: drafts trước, sau đó sort theo createdAt desc
      const sortedConversations = [...(action.payload || [])].sort((a, b) => {
        if (a.isDraft && !b.isDraft) return -1;
        if (!a.isDraft && b.isDraft) return 1;
        // Nếu cả hai đều draft hoặc không draft, sort theo createdAt desc
        const dateA = new Date(a.createdAt || 0);
        const dateB = new Date(b.createdAt || 0);
        return dateB - dateA;
      });

      return {
        ...state,
        conversations: sortedConversations,
      };
    case ticketActions.REPLY_TICKET:
      console.log('[Reducer] REPLY_TICKET:', {
        message: action.payload.message,
        isDraft: action.payload.isDraft,
        payload: action.payload,
      });
      
      // Thêm conversation mới vào đầu mảng và sort lại
      // Draft conversations sẽ được ưu tiên hiển thị ở đầu
      const updatedConversations = [
        action.payload,
        ...state.conversations,
      ].sort((a, b) => {
        // Sort: drafts trước, sau đó sort theo createdAt desc
        if (a.isDraft && !b.isDraft) return -1;
        if (!a.isDraft && b.isDraft) return 1;
        // Nếu cả hai đều draft hoặc không draft, sort theo createdAt desc
        const dateA = new Date(a.createdAt || 0);
        const dateB = new Date(b.createdAt || 0);
        return dateB - dateA;
      });

      const replyDraftMsg = action.payload.message || (action.payload.isDraft ? 'Đã lưu vào nháp' : null);
      console.log('[Reducer] REPLY_TICKET - draftMessage:', replyDraftMsg);

      return {
        ...state,
        conversations: updatedConversations,
        status: 'CREATED',
        // Lưu message để hiển thị notification
        draftMessage: replyDraftMsg,
      };
    case ticketActions.DELETE_CONVERSATION:
      return {
        ...state,
        conversations: state.conversations.filter(conv => conv.id !== action.payload.id),
        status: 'DELETED',
      };

    case ticketActions.TICKET_ERROR:
      return {
        ...state,
        errorMessage: action.payload,
        isFetched: true,
      };

    case ticketActions.RESET_TICKET_STATUS:
      return {
        ...state,
        errorMessage: '',
        status: '',
        draftMessage: null, // Reset message sau khi hiển thị
      };

    default:
      return state;
  }
}
